// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as Belt_List from "../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as StyleUtil from "../domain/common/StyleUtil.bs.js";
import * as EventUtils from "../../../library/partner-app-events/EventUtils.bs.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as RewardCategory from "../domain/types/RewardCategory.bs.js";
import * as RnrAssetManager from "../assets/RnrAssetManager.bs.js";
import * as RnrRouteManager from "../routing/RnrRouteManager.bs.js";
import * as RnrParamsContext from "../utils/version/RnrParamsContext.bs.js";
import * as DateTime$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as RnrClaimedRewardModal from "./RnrModalScreens/RnrClaimedRewardModal.bs.js";
import * as LinkComponent$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/external-link/LinkComponent.bs.js";
import * as PartnerAppEventsConfig from "../../../library/partner-app-events/PartnerAppEventsConfig.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";

var customerServiceLogo = RnrAssetManager.getImage("customer_experience_icon.svg");

var loginHoursLogo = RnrAssetManager.getImage("login_activity_icon.svg");

var orderFulfillmentLogo = RnrAssetManager.getImage("order_fulfillment_icon.svg");

function displayRewardByCategory(date, reward, content, cardPosition) {
  var match = reward.name;
  switch (match) {
    case /* CustomerService */0 :
        return React.createElement("div", {
                    key: RewardCategory.toString(reward.name),
                    className: "history-component__reward-row",
                    onClick: (function (param) {
                        return EventUtils.sendEventToPartnerApp(PartnerAppEventsConfig.daily_rewards_card_clicked, "daily_reward_tab", undefined, DateTime$Catalyst.toString("Do MMM", date), RewardCategory.toDisplayString(reward.name, content), cardPosition, undefined, undefined);
                      })
                  }, React.createElement("div", {
                        className: StyleUtil.getColor(reward.name, "history-component") + " history-component__reward-row-img-box"
                      }, React.createElement("img", {
                            className: "history-component__reward-row-img",
                            src: customerServiceLogo
                          })), React.createElement("div", {
                        className: "history-component__reward-row-info u-flex__col"
                      }, React.createElement("span", {
                            className: "history-component__reward-row-category"
                          }, content.category.customerService), React.createElement("div", {
                            className: "history-component__reward-row-date"
                          }, DateTime$Catalyst.toString("Do MMM", date))), React.createElement("div", {
                        className: "history-component__reward-row-points"
                      }, String(reward.totalPoints) + (" " + content.miscellaneous.points)));
    case /* LoginActivity */1 :
        return React.createElement("div", {
                    key: RewardCategory.toString(reward.name),
                    className: "history-component__reward-row",
                    onClick: (function (param) {
                        return EventUtils.sendEventToPartnerApp(PartnerAppEventsConfig.daily_rewards_card_clicked, "daily_reward_tab", undefined, DateTime$Catalyst.toString("Do MMM", date), RewardCategory.toDisplayString(reward.name, content), cardPosition, undefined, undefined);
                      })
                  }, React.createElement("div", {
                        className: StyleUtil.getColor(reward.name, "history-component") + " history-component__reward-row-img-box"
                      }, React.createElement("img", {
                            className: "history-component__reward-row-img",
                            src: loginHoursLogo
                          })), React.createElement("div", {
                        className: "history-component__reward-row-info u-flex__col"
                      }, React.createElement("span", {
                            className: "history-component__reward-row-category"
                          }, content.category.loginHours), React.createElement("div", {
                            className: "history-component__reward-row-date"
                          }, DateTime$Catalyst.toString("Do MMM ", date))), React.createElement("div", {
                        className: "history-component__reward-row-points"
                      }, String(reward.totalPoints) + (" " + content.miscellaneous.points)));
    case /* OrderFulfillment */2 :
        return React.createElement("div", {
                    key: RewardCategory.toString(reward.name),
                    className: "history-component__reward-row",
                    onClick: (function (param) {
                        return EventUtils.sendEventToPartnerApp(PartnerAppEventsConfig.daily_rewards_card_clicked, "daily_reward_tab", undefined, DateTime$Catalyst.toString("Do MMM", date), RewardCategory.toDisplayString(reward.name, content), cardPosition, undefined, undefined);
                      })
                  }, React.createElement("div", {
                        className: StyleUtil.getColor(reward.name, "history-component") + " history-component__reward-row-img-box"
                      }, React.createElement("img", {
                            className: "history-component__reward-row-img",
                            src: orderFulfillmentLogo
                          })), React.createElement("div", {
                        className: "history-component__reward-row-info u-flex__col"
                      }, React.createElement("span", {
                            className: "history-component__reward-row-category"
                          }, content.category.orderFulfillment), React.createElement("div", {
                            className: "history-component__reward-row-date"
                          }, DateTime$Catalyst.toString("Do MMM", date))), React.createElement("div", {
                        className: "history-component__reward-row-points"
                      }, String(reward.totalPoints) + (" " + content.miscellaneous.points)));
    
  }
}

function displayRewardsByDate(rewardAggByDate, content, prevRewardCount) {
  var rnrParams = RnrParamsContext.getRnrParams(undefined);
  List.map((function (reward) {
          return Belt_List.add(/* [] */0, reward);
        }), rewardAggByDate.rewards);
  return React.createElement("div", {
              key: DateTime$Catalyst.toString(undefined, rewardAggByDate.date),
              className: "history-component__day-container"
            }, ReasonReactUtils$Catalyst.listToReactArray(List.mapi((function (index, reward) {
                        var cardPosition = (prevRewardCount + index | 0) + 1 | 0;
                        return React.createElement(LinkComponent$Catalyst.make, {
                                    href: RnrRouteManager.RouteManager.getURLFromRoute(rnrParams.auth_token, rnrParams.lang, rnrParams.version, {
                                          TAG: /* RewardHistory */1,
                                          _0: rnrParams.uuid,
                                          _1: RewardCategory.toString(reward.name),
                                          _2: Caml_option.some(rewardAggByDate.date)
                                        }),
                                    children: displayRewardByCategory(rewardAggByDate.date, reward, content, cardPosition),
                                    key: RewardCategory.toString(reward.name)
                                  });
                      }), rewardAggByDate.rewards)));
}

function calculatePreviousElementLength(currentIndex, lists) {
  var total = 0;
  for(var i = 0; i < currentIndex; ++i){
    total = total + Belt_List.length(List.nth(lists, i).rewards) | 0;
  }
  return total;
}

function getView(viewModel, content, showModal, selectedDate, selectedCategory, onRewardToggle) {
  return React.createElement("div", undefined, ReasonReactUtils$Catalyst.listToReactArray(List.mapi((function (index, claimedReward) {
                        var prevRewardCount = calculatePreviousElementLength(index, viewModel.claimedRewards);
                        return React.createElement("div", undefined, React.createElement("div", {
                                        className: "history-component__date-separator"
                                      }, DateTime$Catalyst.toString("Do MMM YYYY", claimedReward.date)), displayRewardsByDate(claimedReward, content, prevRewardCount));
                      }), viewModel.claimedRewards)), showModal ? React.createElement(RnrClaimedRewardModal.make, {
                    rewards: viewModel.claimedRewards,
                    content: content,
                    selectedDate: selectedDate,
                    selectedCategory: selectedCategory,
                    onRewardToggle: onRewardToggle,
                    requestState: undefined
                  }) : null);
}

var RewardHistoryViewMapper = {
  displayRewardByCategory: displayRewardByCategory,
  displayRewardsByDate: displayRewardsByDate,
  calculatePreviousElementLength: calculatePreviousElementLength,
  getView: getView
};

export {
  customerServiceLogo ,
  loginHoursLogo ,
  orderFulfillmentLogo ,
  RewardHistoryViewMapper ,
  
}
/* customerServiceLogo Not a pure module */
